import { useCredentialsQuery } from '@capsicum/socios-core';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { isRequirementsPageAtom } from '../data-access/atoms/requirements.atom';

/**
 * Hook to handle the common forced requirements flow
 */
export const useForcedRequirementsCheckerFlow = (next: () => void) => {
	const isRequirementsPage = useAtomValue(isRequirementsPageAtom);
	const { areCredentialsFetching, forcedRequirementsIdentifiers } = useCredentialsQuery();

	const firstForcedRequirement = forcedRequirementsIdentifiers?.[0];

	const shouldShowForcedRequirements = Boolean(firstForcedRequirement && !isRequirementsPage);

	useEffect(() => {
		if (isRequirementsPage || (!areCredentialsFetching && !firstForcedRequirement)) {
			next();
		}
	}, [areCredentialsFetching, forcedRequirementsIdentifiers, isRequirementsPage]);

	return {
		areCredentialsFetching,
		firstForcedRequirement,
		shouldShowForcedRequirements
	};
};
